<div class="step-container registration-add-children">
  <ng-container *ngIf="isLoaded$ | async; else loading">
    <h5 class="registration-add-children-title">
      {{ 'fgbcl.registration.add.children.title' | translate: { fgbdefault: 'Add Kids' } }}
    </h5>
    <p
      class="registration-add-children-instructions"
      [innerHtml]="'fgbcl.registration.add.children.instructions' | translate | markdownTranslate"
    ></p>
    <hr />
    <div class="form-container">
      <form [formGroup]="childrenForm" *ngIf="childModel?.length > 0">
        <div class="children-form-container" formArrayName="children">
          <div class="child-form" *ngFor="let child of childrenForm?.get('children')?.controls; let i = index">
            <h5 class="child-title">
              {{ 'fgbcl.registration.add.children.child.description.title' | translate: { fgbdefault: 'Child' } }} {{ i + 1 }}
            </h5>
            <fgbcl-model-meta-data-form
              [formGroupName]="i"
              wscPrefix="fgbcl.registration.add.children"
              [models]="childModel"
              [minDate]="{ year: today.getFullYear() - maxAge, month: today.getMonth() + 1, day: today.getDate() + 1 }"
              [maxDate]="{ year: today.getFullYear() - minAge, month: today.getMonth() + 1, day: today.getDate() }"
            ></fgbcl-model-meta-data-form>

            <button class="btn-clear" (click)="clearChildAt(i)" *ngIf="childrenForm?.get('children').value?.length === 1">
              {{ 'fgbcl.registration.add.children.clear.button' | translate: { fgbdefault: 'Clear' } }}
            </button>
            <button class="btn-delete" (click)="removeChildAt(i)" *ngIf="childrenForm?.get('children').value?.length > 1">
              {{ 'fgbcl.registration.add.children.delete.button' | translate: { fgbdefault: 'Delete' } }}
            </button>
          </div>
        </div>

        <div class="button-wrapper">
          <a class="btn add-btn" *ngIf="childrenForm?.get('children')?.controls.length < childLimit" (click)="addChild()">
            <i class="material-icons">add</i>
            <label>{{ 'registration.add.children.add.button.label' | translate }}</label>
          </a>
        </div>
      </form>
    </div>
    <!-- Server Side Errors -->
    <fgbcl-errors></fgbcl-errors>

    <div class="registration-navigataion-button-container">
      <fgbcl-registration-navigation (nextButtonClicked)="submitStep()" [stepType]="stepType"></fgbcl-registration-navigation>
    </div>
  </ng-container>

  <ng-template #loading>
    <div class="w-100">
      <fgbcl-loading></fgbcl-loading>
    </div>
  </ng-template>
</div>
